<template>
  <div class="flex-grow-1">
    <header-bar />
    <v-card>
      <v-card-text class="ml-4">
        <div class="h1 mb-2">Warranty Information</div>
        <div class="ml-4">
          <div class="h2">Last Updated: July 22, 2024</div>
          <div class="body mb-4">
            Thank you for choosing Sigflō for your product needs. We strive to
            provide you with a wide range of high-quality products from various
            manufacturers. Please take a moment to review our warranty policy to
            understand how warranties are handled for products purchased from
            our website.
          </div>
          <div class="h2">No Warranty by Sigflō</div>
          <div class="body mb-4">
            Sigflō does not offer any warranty of any kind for the products sold
            on our website. All warranties, if applicable, are provided and
            processed by the respective manufacturers of the products.
          </div>
          <div class="h2">Manufacturer Warranties</div>
          <div class="body mb-4">
            Each manufacturer may have its own warranty terms and conditions. To
            determine the specific warranty coverage for a product, please refer
            to the documentation provided by the manufacturer. This
            documentation is typically included with the product or can be found
            on the manufacturer's website.
          </div>
          <div class="h2">How to Obtain Warranty Service</div>
          <div class="body mb-4">
            If you need to request warranty service for a product purchased from
            Sigflō, please follow these steps:
          </div>
          <div class="body mb-4">
            <ol>
              <li>
                Review the Manufacturer's Warranty: Locate the warranty
                information provided by the manufacturer. This may include
                warranty terms, coverage details, and instructions for obtaining
                service.
              </li>
              <li>
                Contact the Manufacturer: Reach out to the manufacturer directly
                using the contact information provided in the warranty
                documentation or on the manufacturer's website. They will guide
                you through the process of obtaining warranty service.
              </li>
              <li>
                Provide Necessary Information: Be prepared to provide proof of
                purchase, product details, and a description of the issue when
                contacting the manufacturer
              </li>
            </ol>
          </div>
          <div class="h2">Product Registration</div>
          <div class="body mb-4">
            We encourage customers to register their products with the
            manufacturer to guarantee the best warranty coverage after purchase.
            Registration can often provide additional benefits and ensure a
            smooth warranty service experience.
          </div>
          <div class="h2">Limitation of Liability</div>
          <div class="body mb-4">
            Sigflō is not responsible for any damages, losses, or costs
            associated with warranty claims or the performance of products. All
            liability for warranty claims rests with the manufacturer of the
            product.
          </div>
        </div>
      </v-card-text>
      <v-card-text class="ml-4">
        <div class="h1 mb-4">Return Policy</div>
        <div class="body ml-4 mb-4">
          <div class="h2 mb-4">
            At Sigflō, we strive to ensure you are completely satisfied with
            your purchase. If you are not satisfied, we offer a 30-day return
            policy under the following conditions:
          </div>
          <ol class="h2">
            <li>
              <div class="h2">30-Day Return Window:</div>
              <div class="body">
                Items must be returned within 30 days from the date of purchase.
              </div>
            </li>
            <li>
              <div class="h2">Original Packaging:</div>
              <div class="body">
                All returned items must be in their original packaging and in
                the same condition as when they were received.
              </div>
            </li>
            <li>
              <div class="h2">Shipping Charges:</div>
              <div class="body">
                Customers are responsible for all shipping charges related to
                the return of the item.
              </div>
            </li>
            <li>
              <div class="h2">Non-Returnable Items:</div>
              <div class="body">
                Custom items are non-returnable and non-refundable.
              </div>
            </li>
            <li>
              <div class="h2">
                Return Merchandise Authorization (RMA) Number:
              </div>
              <div class="body">
                <ul>
                  <li>
                    Prior to returning an item, you must obtain an RMA number
                    from Sigflō. This will ensure that your return is processed
                    correctly and your account is credited properly.
                  </li>
                  <li>
                    To obtain an RMA number, please contact our customer service
                    team at
                    <a
                      @click="handleEmailClick"
                      href="mailto:support@sigflo.com"
                      >support@sigflo.com</a
                    >
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div class="h2">Restocking Fee:</div>
              <div class="body">
                A restocking fee may be applied if the original packaging or
                accessories are missing, or if there is any damage to the
                product.
              </div>
            </li>
          </ol>
          <div class="h2 mb-2 mt-6">Return Process:</div>
          <div class="body">
            <ol>
              <li>
                Contact our customer service team to obtain an RMA number.
              </li>
              <li>
                Pack the item securely in its original packaging, including all
                parts, accessories, and documentation.
              </li>
              <li>
                Write the RMA number clearly on the outside of the package.
              </li>
              <li>
                Ship the item to the address provided by our customer service
                team.
              </li>
            </ol>
            <div class="body">
              Please note that items returned without an RMA number may not be
              accepted or may delay the processing of your return.
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <footer-bar />
  </div>
</template>

<script>
  import headerBar from '@/components/shared/HeaderBar.vue';
  import footerBar from '@/components/shared/FooterBar.vue';

  export default {
    components: {
      headerBar,
      footerBar
    },
    methods: {}
  };
</script>

<style scoped>
  .h1 {
    color: black;
    font-size: 2rem;
    line-height: 2;
    font-weight: bold;
  }
  .h2 {
    font-size: 1rem;
    font-weight: bold;
    color: black;
  }
  .body {
    font-weight: normal;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.7);
  }
</style>
